import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { comparerByAlphabet } from '@app/comparers';
import { BusinessUnit } from '@app/models/business-unit';
import {
  BusinessUnitActionTypes,
  BusinessUnitActionsUnion
} from '@core/actions/business-unit.actions';

import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<BusinessUnit> {
  loading: boolean;
  loaded: boolean;
  busy: boolean;
  businessByFollowId: any;
}

export const adapter: EntityAdapter<BusinessUnit> = createEntityAdapter<
  BusinessUnit
>({
  selectId: (businessUnit: BusinessUnit) => businessUnit.id,
  sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  busy: false,
  businessByFollowId: []
});

export function reducer(
  state: State = INITIAL_STATE,
  action: BusinessUnitActionsUnion
) {
  switch (action.type) {
    case BusinessUnitActionTypes.Load:
    case BusinessUnitActionTypes.Create:
    case BusinessUnitActionTypes.AddOne:
    case BusinessUnitActionTypes.DeleteOne:
    case BusinessUnitActionTypes.LoadByFollowId:
      return { ...state, loading: true, busy: true };

    case BusinessUnitActionTypes.LoadFail:
    case BusinessUnitActionTypes.CreateFail:
    case BusinessUnitActionTypes.AddOneFail:
    case BusinessUnitActionTypes.LoadByFollowIdFail:
      return { ...state, loading: false, busy: false };

    case BusinessUnitActionTypes.LoadByFollowIdSuccess:
      return {
        ...state,
        businessByFollowId: action.data
      }

      case BusinessUnitActionTypes.DeleteOneSuccess:
        return {
          ...state,
          loading: false,
          busy: false,
          businessByFollowId: [
            ...state.businessByFollowId.filter((x) => x.id !== action.BusinessId),
          ]
        }
    
    case BusinessUnitActionTypes.AddOneSuccess:
      return {
        ...state,
        loading: false,
        busy: false,
        businessByFollowId: [
          ...state.businessByFollowId.filter((x) => x.id !== action.data.id),
          action.data
        ]
      }

    case BusinessUnitActionTypes.LoadSuccess:
      return adapter.addAll(action.businessUnits, {
        ...state,
        loading: false,
        loaded: true,
        busy: false
      });

    case BusinessUnitActionTypes.CreateSuccess:
      return { ...state, loading: false, busy: false };

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;

const getState = createFeatureSelector<State>('businessUnits');

export const getAll = createSelector(
  getState,
  selectAll
);

export const isBusy = createSelector(
  getState,
  (state: State) => state.busy
)

export const getBusinessByFollowId = createSelector(
  getState,
  (state: State) => state.businessByFollowId
)